import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: [
            {
                key: 'taskCheck.ticket.customerId',
                trans: 'Customers',
                keyService: 'Customers',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.CUSTOMER],
            },
            {
                key: 'taskCheck.deviceId',
                trans: 'Devices',
                keyService: 'Devices',
                defaultOperator: '=',
            },
            {
                key: 'taskCheck.assigneeId',
                trans: 'Assignees.violationDetailTaskCheck',
                keyService: 'Assignees',
                defaultOperator: '=',
                excludeRoles: [RoleEnum.KTV],
            },
        ],
        type: 'orm',
        value: [],
    },
    {
        key: [
            { key: 'createdDate', trans: 'createdDate', defaultOperator: '=' },
        ],
        type: 'date',
        value: [],
    },
];
